import { render } from "./AiPromptCard.vue?vue&type=template&id=46d96f24"
import script from "./AiPromptCard.vue?vue&type=script&lang=js"
export * from "./AiPromptCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__